<div class="complyon-demo">
  <!-- Header -->
  <h2 class="gradient-text fw-bold">ComplyOn</h2>
  <p class="text-muted mb-4">
    Auto Verification - Automated identity, location, and legitimacy verification
  </p>

  <!-- Stats Bar -->
  <div class="row g-3 mb-3">
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-primary">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="text-muted small">Real-Time Processing</span>
            <i class="fa fa-bolt text-primary me-2"></i>
          </div>
          <div class="h4 fw-bold mb-0">Instant</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-success">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="text-muted small">Fraud Reduction</span>
            <i class="fa fa-shield-alt text-success me-2"></i>
          </div>
          <div class="h4 fw-bold mb-0">Maximized</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="text-muted small">Bureau Integration</span>
            <i class="fa fa-plug text-danger me-2"></i>
          </div>
          <div class="h4 fw-bold mb-0">Seamless</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-warning">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="text-muted small">Manual Checks</span>
            <i class="fa fa-times-circle text-warning me-2"></i>
          </div>
          <div class="h4 fw-bold mb-0">Eliminated</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Auto Verification Cards Grid -->
  <div class="row g-4">
    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-user-check gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Identity & Location Verification</h5>
          </div>
          <p class="text-muted mb-3 small">
            Automatically verifies the identity and location of individuals during onboarding by connecting in real time to trusted credit bureaus.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('verification')">
            <i class="fa fa-bolt me-2"></i>Verify Identity
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-building gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Company Legitimacy Check</h5>
          </div>
          <p class="text-muted mb-3 small">
            Validates the legitimacy of a company and the legal status of entities instantly using integrated credit bureaus and authoritative data sources.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('verification')">
            <i class="fa fa-search me-2"></i>Validate Company
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-chart-line gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Credit Standing Assessment</h5>
          </div>
          <p class="text-muted mb-3 small">
            Evaluates the credit standing of individuals or companies by securely sending captured data to integrated bureaus and receiving authoritative results.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('verification')">
            <i class="fa fa-file-invoice-dollar me-2"></i>Assess Credit
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 d-none">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-sync gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Real-Time Bureau Integration</h5>
          </div>
          <p class="text-muted mb-3 small">
            Instead of relying on manual checks, the system connects in real time to trusted credit bureaus to validate applicant or entity information instantly.
          </p>
          <button class="btn upload-button text-white w-100">
            <i class="fa fa-link me-2"></i>Integrate Bureau
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

